import { deepPurple, purple } from "@mui/material/colors"
import { styled } from "@mui/system"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { createShape, moveVertex, translateShape } from "./shapes"
import VertexSelector from "./VertexSelectors"

const StyledClipPathElement = styled('div')(({ selected }) => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  position: 'absolute',
  background: selected ? purple[500] : deepPurple[500],
  mixBlendMode: 'overlay',
  '&:hover': {
    mixBlendMode: 'screen'
  }
}))

const ClipPathElement = ({ elementRef, clipPath, item, width, height, selected, isEditing, onClick, onDoubleClick, onVertexHover, onShapeHover, update }) => {
  const clipPathRef = useRef()
  const [shape, setShape] = useState(() => createShape(clipPath, width, height))
  const [aClipPath, setClipPath] = useState(shape.clipPath)

  const handleClick = useCallback(() => onClick && onClick(item), [item, onClick])
  const handleDoubleClick = useCallback(() => onDoubleClick && onDoubleClick(item), [item, onDoubleClick])
  const handleVertexHover = useCallback((vertex) => onVertexHover && onVertexHover(vertex), [onVertexHover])
  const handleGetClipPath = useCallback(() => shape.clipPath, [shape])

  const handleMoveVertex = useCallback((vertexIndex, x, y) => {
    moveVertex(shape, vertexIndex, x, y)
    setClipPath(shape.clipPath)
  }, [shape])

  const handleTranslateShape = useCallback((x, y) => {
    translateShape(shape, x, y)
    setClipPath(shape.clipPath)
  }, [shape])

  const handleMouseOver = useCallback(() => {
    const data = {
      item,
      translate: handleTranslateShape,
      getShapeClipPath: handleGetClipPath
    }
    if (onShapeHover) onShapeHover(data, true)
  }, [item, onShapeHover, handleTranslateShape, handleGetClipPath])

  const handleMouseLeave = useCallback(() => {
    const data = {
      item
    }
    if (onShapeHover) onShapeHover(data, false)
  }, [item, onShapeHover])

  useLayoutEffect(() => {
    if (selected) elementRef.current = clipPathRef.current
  }, [selected, elementRef])

  useEffect(() => {
    if(clipPath) {
      setClipPath(clipPath)
      setShape(createShape(clipPath, width, height))
    }
  },[update, clipPath, width, height])

  return (
    <>
      <StyledClipPathElement
        ref={clipPathRef}
        selected={selected}
        style={{ clipPath: aClipPath || clipPath }}
        onClick={handleClick}
        onDoubleClick={handleDoubleClick}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
      />
      {isEditing && shape.verteces.map((vertex, index) => 
        <VertexSelector
          x={vertex.x}
          y={vertex.y}
          key={index} 
          vertexIndex={index} 
          onVertexHover={handleVertexHover} 
          getShapeClipPath={handleGetClipPath}
          moveVertex={handleMoveVertex}
        />
      )}
    </>        
  )
}

export default ClipPathElement